import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BarChart3, Menu, X } from "lucide-react";
import { NAV_ITEMS } from "@/lib/content";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else {
    const y = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (target) => {
    setOpen(false);
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(target), 400);
    } else {
      scrollToId(target);
    }
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 bg-navy-950/95 backdrop-blur-md ${
        scrolled ? "shadow-lg shadow-black/30 py-3 border-b border-white/5" : "py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <button
          data-testid="logo-home"
          onClick={() => handleNav("anasayfa")}
          className="flex items-center gap-3 group"
        >
          <span className="grid place-items-center h-11 w-11 rounded-lg bg-navy-800 ring-1 ring-white/10">
            <BarChart3 className="h-6 w-6 text-brand-400" strokeWidth={2.5} />
          </span>
          <span className="font-display leading-none text-left">
            <span className="block text-white font-extrabold tracking-tight text-lg">TÜRKİYE</span>
            <span className="block text-white font-extrabold tracking-tight text-lg">BORSASI</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_ITEMS.map((it) => (
            <button
              key={it.target}
              data-testid={`nav-${it.target}`}
              onClick={() => handleNav(it.target)}
              className="text-sm text-white/75 hover:text-white transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 hover:after:w-full after:bg-brand-400 after:transition-all after:duration-300"
            >
              {it.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden mt-3 mx-4 rounded-2xl bg-navy-900/95 backdrop-blur-xl border border-white/10 p-3">
          {NAV_ITEMS.map((it) => (
            <button
              key={it.target}
              data-testid={`nav-mobile-${it.target}`}
              onClick={() => handleNav(it.target)}
              className="block w-full text-left px-4 py-3 rounded-xl text-white/80 hover:bg-white/5 hover:text-white transition-colors"
            >
              {it.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
